import "./AnnouncementBar.css";

function AnnouncementBar() {
  return (
    <div className="announcement-bar">
      <span className="announcement-dot"></span>

      <span>
        EPU Index.PL, January 2000 to June 2026 · free to read and reuse
      </span>

      <a href="research.html">
        See the data ↗
      </a>
    </div>
  );
}

export default AnnouncementBar;

